import { PayPointsPageContent } from "Components/Merchant/PayPointsPageContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";

export const PayPointsPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.PayPoints)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null,
      }}
    >
      <StyledPageWrapper>
        <div className="left-content" style={{ width: "100%", height: "100%" }}>
          <PayPointsPageContent />
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
